import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { visitNotesApi, type VisitNote } from "../lib/apiClient";
import { VisitNoteForm } from "../components/VisitNoteForm";
import { formatVisitDate } from "../lib/formatDate";

export function VisitNoteDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [note, setNote] = useState<VisitNote | null>(null);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    visitNotesApi
      .get(id)
      .then(setNote)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p>Loading…</p>;
  if (error) return <p role="alert">{error}</p>;
  if (!note || !id) return <p>Not found.</p>;

  const handleDelete = async () => {
    if (!confirm("Delete this visit note?")) return;
    await visitNotesApi.remove(id);
    navigate("/");
  };

  if (editing) {
    return (
      <VisitNoteForm
        submitLabel="Save"
        initialValue={{
          patientName: note.patientName,
          doctorName: note.doctorName,
          visitDate: note.visitDate,
          diagnosis: note.diagnosis ?? "",
          notes: note.notes,
        }}
        onSubmit={async (input) => {
          const updated = await visitNotesApi.update(id, input);
          setNote(updated);
          setEditing(false);
        }}
      />
    );
  }

  return (
    <div>
      <Link to="/">&larr; Back</Link>
      <h1>{note.patientName}</h1>
      <dl>
        <dt>Doctor</dt>
        <dd>{note.doctorName}</dd>
        <dt>Visit date</dt>
        <dd>{formatVisitDate(note.visitDate)}</dd>
        <dt>Diagnosis</dt>
        <dd>{note.diagnosis ?? "—"}</dd>
        <dt>Notes</dt>
        <dd>{note.notes}</dd>
      </dl>
      <button type="button" onClick={() => setEditing(true)}>
        Edit
      </button>
      <button type="button" onClick={() => void handleDelete()}>
        Delete
      </button>
    </div>
  );
}
